<template>
  <v-app>
    <NavBar />
    <v-main class="sub-box">
      <section class="sub-box__content">
        <v-container>
          <v-row class="justify-center mt-12 main-title">
            <h1
              id="content-t"
              class="change-font sub-box__title"
              style="z-index: 1; margin-bottom: 20px"
            >
              Select Your {{ planName }}<span v-if="$route.params.plan !== 'corporate'">: Monthly or Yearly</span>
            </h1>
          </v-row>
          <v-card
            class="mx-auto discount"
            max-width="700"
            elevation="8"
          >
            <v-radio-group v-model="period">
              <div class="discount__label">
                <span
                  v-if="showOffBanner"
                  class="off-text-yearly"
                >40% <span>OFF</span>
                </span>
              </div>
              <v-card-text
                class="px-8 discount__box"
                @click="setPeriod(YEAR)"
              >
                <v-row class="flex-nowrap pay-block">
                  <v-radio
                    ref="RadioYear"
                    class="mr-4"
                    value="year"
                    color="#7261c9"
                  />
                  <span
                    class="text-h6 font-weight-bold"
                    style="width: 200px"
                  >
                    Pay Yearly </span><span
                    class="text-h6 font-weight-bold"
                  >${{ yearlyPlanPrice }}</span>
                </v-row>
              </v-card-text>
              <v-divider v-if="monthlyPlan" />
              <v-card-text
                v-if="monthlyPlan"
                class="px-8 discount__box"
                @click="setPeriod(MONTH)"
              >
                <v-row class="flex-nowrap pay-block">
                  <v-radio
                    ref="RadioMonth"
                    class="mr-4"
                    value="month"
                    color="#7261c9"
                  />
                  <span
                    class="text-h6 font-weight-bold"
                    style="width: 200px"
                  >
                    Pay Monthly </span><span
                    class="text-h6 font-weight-bold"
                  >${{ monthlyPlanPrice }}</span>
                </v-row>
              </v-card-text>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto px-2 my-12"
            max-width="700"
            flat
          >
            <v-row class="justify-space-between btn-block">
              <v-btn
                outlined
                color="#7671bd"
                @click="back"
              >
                BACK
              </v-btn>
              <v-btn
                class="btn-buy"
                @click="buyNow"
              >
                BUY NOW
              </v-btn>
            </v-row>
          </v-card>
        </v-container>
        <v-row class="mt-12 mb-8" style="background-color: #F7F7F7;">
          <v-col>
            <v-container>
              <v-row class="justify-center information my-6">
                <v-col
                  xs="12"
                  sm="3"
                  md="3"
                  cols="12"
                >
                  <v-row class="flex-nowrap information__block align-center">
                    <p>ACCEPTED PAYMENT METHODS</p>
                  </v-row>
                  <v-row class="flex-nowrap information__imgcard">
                    <v-col class="pa-0">
                      <v-img
                        max-width="44"
                        src="@/assets/icons/svg/visa.svg"
                      />
                    </v-col>
                    <v-col class="pa-0">
                      <v-img
                        max-width="44"
                        src="@/assets/icons/svg/mastercard.svg"
                      />
                    </v-col>
                    <v-col class="pa-0">
                      <v-img
                        max-width="44"
                        src="@/assets/icons/svg/amex.svg"
                      />
                    </v-col>
                    <v-col class="pa-0">
                      <v-img
                        max-width="44"
                        src="@/assets/icons/svg/unionpay.svg"
                      />
                    </v-col>
                    <v-col class="pa-0">
                      <v-img
                        max-width="44"
                        src="@/assets/icons/svg/diners.svg"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider
                  vertical
                  class="my-8 mx-4"
                />
                <v-col
                  xs="12"
                  sm="3"
                  md="3"
                  cols="12"
                >
                  <v-row class="flex-nowrap justify-center align-center information__block">
                    <svg width="56" height="56" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.5 25.5H14.9883L13.1675 23.6734C13.3212 23.6045 13.4621 23.5098 13.584 23.3935C13.8659 23.1114 14.0242 22.7289 14.0242 22.33C14.0242 21.9312 13.8659 21.5487 13.584 21.2665L10.4033 18.0868C10.2184 17.9003 9.99828 17.7523 9.75569 17.6516C9.51311 17.5509 9.25292 17.4993 8.99025 17.5H6.99902V17.001C6.99906 16.9353 6.98615 16.8703 6.96104 16.8096C6.93593 16.7489 6.8991 16.6938 6.85266 16.6473C6.80622 16.6009 6.75109 16.5641 6.69041 16.539C6.62973 16.5138 6.5647 16.5009 6.49902 16.501H2.99902V16.001C2.99902 15.8684 2.94635 15.7412 2.85258 15.6474C2.75881 15.5537 2.63163 15.501 2.49902 15.501C2.36642 15.501 2.23924 15.5537 2.14547 15.6474C2.0517 15.7412 1.99902 15.8684 1.99902 16.001V26.001C1.99902 26.1336 2.0517 26.2608 2.14547 26.3545C2.23924 26.4483 2.36642 26.501 2.49902 26.501C2.63163 26.501 2.75881 26.4483 2.85258 26.3545C2.94635 26.2608 2.99902 26.1336 2.99902 26.001V25.501H6.49902C6.56469 25.501 6.62973 25.4881 6.69041 25.463C6.75109 25.4379 6.80622 25.401 6.85266 25.3546C6.8991 25.3082 6.93592 25.253 6.96104 25.1924C6.98615 25.1317 6.99906 25.0666 6.99902 25.001V24.9336L12.2227 28.416C12.3048 28.4707 12.4013 28.4999 12.5 28.5H13C13.1326 28.5 13.2598 28.4473 13.3536 28.3535C13.4473 28.2598 13.5 28.1326 13.5 28C13.5 27.8674 13.4473 27.7402 13.3536 27.6464C13.2598 27.5527 13.1326 27.5 13 27.5H12.6514L7.00002 23.7324V18.5H8.99025C9.12153 18.4999 9.25152 18.5258 9.37271 18.5763C9.4939 18.6267 9.60389 18.7007 9.69631 18.7939L12.877 21.9736C12.97 22.0688 13.022 22.1965 13.022 22.3296C13.022 22.4626 12.97 22.5904 12.877 22.6855C12.7871 22.7764 12.6652 22.8284 12.5374 22.8304C12.4096 22.8324 12.2861 22.7843 12.1934 22.6963L12.186 22.6917C12.1718 22.6779 12.1566 22.6651 12.1407 22.6533L9.85647 20.3594C9.76311 20.2666 9.63694 20.2144 9.50534 20.2141C9.37373 20.2137 9.2473 20.2653 9.15348 20.3576C9.05965 20.4499 9.00599 20.5754 9.00413 20.707C9.00228 20.8386 9.05238 20.9656 9.14357 21.0605L11.4668 23.3935C11.4863 23.4126 11.5072 23.4302 11.5293 23.4463L14.4258 26.3525C14.4722 26.3993 14.5274 26.4364 14.5883 26.4617C14.6491 26.487 14.7144 26.5 14.7803 26.5H18.5C18.6979 26.5002 18.8937 26.54 19.076 26.6169C19.2583 26.6939 19.4234 26.8065 19.5615 26.9482C19.7194 27.1028 19.8397 27.2916 19.9131 27.5H17C16.8674 27.5 16.7402 27.5527 16.6465 27.6464C16.5527 27.7402 16.5 27.8674 16.5 28C16.5 28.1326 16.5527 28.2598 16.6465 28.3535C16.7402 28.4473 16.8674 28.5 17 28.5H20.5C20.5657 28.5 20.6307 28.4871 20.6914 28.462C20.7521 28.4369 20.8072 28.4001 20.8537 28.3536C20.9001 28.3072 20.9369 28.252 20.962 28.1914C20.9872 28.1307 21.0001 28.0656 21 28C20.9963 27.3381 20.7317 26.7043 20.2637 26.2363C19.7957 25.7683 19.1619 25.5037 18.5 25.5ZM5.99902 24.501H2.99902V17.501H5.99902V24.501Z" fill="#999999"/>
                      <path d="M4.49866 23.5007C4.7748 23.5007 4.99866 23.2769 4.99866 23.0007C4.99866 22.7246 4.7748 22.5007 4.49866 22.5007C4.22251 22.5007 3.99866 22.7246 3.99866 23.0007C3.99866 23.2769 4.22251 23.5007 4.49866 23.5007Z" fill="#999999"/>
                      <path d="M21.4756 3.89256C18.5632 3.11063 15.46 3.50528 12.836 4.99133C10.2119 6.47738 8.27743 8.93565 7.45005 11.8355L6.63291 10.4199C6.60023 10.3628 6.55659 10.3127 6.5045 10.2725C6.45242 10.2323 6.39291 10.2028 6.32938 10.1857C6.26586 10.1685 6.19958 10.1641 6.13435 10.1727C6.06911 10.1812 6.00621 10.2025 5.94924 10.2355C5.89228 10.2684 5.84238 10.3122 5.8024 10.3645C5.76242 10.4167 5.73316 10.4764 5.71629 10.54C5.69942 10.6036 5.69528 10.6699 5.70409 10.7351C5.71291 10.8003 5.73452 10.8631 5.76768 10.9199L7.18174 13.3701C7.21436 13.427 7.2579 13.4769 7.30985 13.517C7.3618 13.557 7.42114 13.5864 7.48448 13.6035C7.52693 13.6143 7.57055 13.6199 7.61436 13.6201C7.70221 13.6203 7.78852 13.5971 7.86436 13.5527L10.3145 12.1377C10.4292 12.0714 10.5129 11.9622 10.5471 11.8342C10.5813 11.7062 10.5633 11.5699 10.497 11.4552C10.4307 11.3405 10.3216 11.2568 10.1936 11.2225C10.0656 11.1883 9.92928 11.2062 9.81455 11.2725L8.42387 12.0748C8.91477 10.3864 9.82202 8.84838 11.0623 7.60198C12.3025 6.35558 13.8361 5.44076 15.5221 4.94152C17.2081 4.44229 18.9924 4.37465 20.7114 4.74481C22.4303 5.11497 24.0287 5.91106 25.3598 7.05999C26.6909 8.20891 27.7119 9.67385 28.3293 11.3203C28.9466 12.9667 29.1404 14.7418 28.8928 16.4826C28.6453 18.2235 27.9643 19.8742 26.9125 21.2833C25.8607 22.6923 24.4717 23.8145 22.8731 24.5469C22.8135 24.5743 22.7598 24.6132 22.7152 24.6614C22.6706 24.7096 22.636 24.7661 22.6132 24.8276C22.5905 24.8892 22.58 24.9547 22.5826 25.0203C22.5851 25.0859 22.6006 25.1503 22.628 25.21C22.6554 25.2696 22.6944 25.3232 22.7425 25.3678C22.7907 25.4124 22.8472 25.4471 22.9088 25.4698C22.9704 25.4926 23.0358 25.503 23.1014 25.5005C23.167 25.4979 23.2315 25.4825 23.2911 25.4551C25.4424 24.469 27.2371 22.8433 28.4303 20.7997C29.6236 18.7561 30.1574 16.3941 29.9589 14.036C29.7603 11.6779 28.8391 9.43839 27.321 7.62308C25.8028 5.80777 23.7615 4.50503 21.4756 3.89256Z" fill="#999999"/>
                      <path d="M21.499 12.501C21.6316 12.501 21.7588 12.4483 21.8526 12.3545C21.9463 12.2608 21.999 12.1336 21.999 12.001C21.999 11.8684 21.9463 11.7412 21.8526 11.6474C21.7588 11.5537 21.6316 11.501 21.499 11.501H18.999V11.001C18.999 10.8684 18.9463 10.7412 18.8526 10.6474C18.7588 10.5537 18.6316 10.501 18.499 10.501C18.3664 10.501 18.2392 10.5537 18.1455 10.6474C18.0517 10.7412 17.999 10.8684 17.999 11.001V11.501H16.999C16.4686 11.501 15.9599 11.7117 15.5848 12.0868C15.2097 12.4618 14.999 12.9705 14.999 13.501C14.999 14.0314 15.2097 14.5401 15.5848 14.9152C15.9599 15.2903 16.4686 15.501 16.999 15.501H17.999V17.501H15.499C15.3664 17.501 15.2392 17.5537 15.1455 17.6474C15.0517 17.7412 14.999 17.8684 14.999 18.001C14.999 18.1336 15.0517 18.2608 15.1455 18.3545C15.2392 18.4483 15.3664 18.501 15.499 18.501H17.999V19.001C17.999 19.1336 18.0517 19.2608 18.1455 19.3545C18.2392 19.4483 18.3664 19.501 18.499 19.501C18.6316 19.501 18.7588 19.4483 18.8526 19.3545C18.9463 19.2608 18.999 19.1336 18.999 19.001V18.501H19.999C20.5295 18.501 21.0382 18.2903 21.4132 17.9152C21.7883 17.5401 21.999 17.0314 21.999 16.501C21.999 15.9705 21.7883 15.4618 21.4132 15.0868C21.0382 14.7117 20.5295 14.501 19.999 14.501H18.999V12.501H21.499ZM19.999 15.501C20.1303 15.501 20.2604 15.5268 20.3817 15.5771C20.503 15.6274 20.6133 15.701 20.7061 15.7939C20.799 15.8867 20.8726 15.997 20.9229 16.1183C20.9732 16.2396 20.999 16.3697 20.999 16.501C20.999 16.6323 20.9732 16.7623 20.9229 16.8837C20.8726 17.005 20.799 17.1152 20.7061 17.2081C20.6133 17.3009 20.503 17.3746 20.3817 17.4249C20.2604 17.4751 20.1303 17.501 19.999 17.501H18.999V15.501H19.999ZM17.999 14.501H16.999C16.7338 14.501 16.4795 14.3956 16.2919 14.2081C16.1044 14.0205 15.999 13.7662 15.999 13.501C15.999 13.2358 16.1044 12.9814 16.2919 12.7939C16.4795 12.6063 16.7338 12.501 16.999 12.501H17.999V14.501Z" fill="#999999"/>
                      <path d="M15 28.5C15.2761 28.5 15.5 28.2761 15.5 28C15.5 27.7239 15.2761 27.5 15 27.5C14.7239 27.5 14.5 27.7239 14.5 28C14.5 28.2761 14.7239 28.5 15 28.5Z" fill="#999999"/>
                    </svg>
                    <p class="pl-4" style="max-width: 220px;">15 DAY MONEY BACK GUARANTEE ON ALL PLANS</p>
                  </v-row>
                </v-col>
                <v-divider
                  vertical
                  class="my-8 mx-4"
                />
                <v-col
                  xs="12"
                  sm="3"
                  md="3"
                  cols="12"
                >
                  <v-row class="flex-nowrap justify-center align-center information__block">
                    <svg width="56" height="56" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M27.0633 8.19291C27.0538 8.11186 27.0223 8.03474 26.9721 7.96948C26.922 7.90421 26.8549 7.85315 26.7778 7.82155L15.7798 3.04616C15.7091 3.01572 15.6327 3 15.5554 3C15.4782 3 15.4018 3.01572 15.3311 3.04616L4.33309 7.82088C4.25591 7.85255 4.18877 7.9037 4.13859 7.9691C4.08841 8.03449 4.05701 8.11174 4.0476 8.19291C4.03265 8.33748 3.71725 11.7686 4.93261 15.9598C5.64837 18.4281 6.75021 20.643 8.20824 22.5416C10.0367 24.9237 12.4294 26.8097 15.3196 28.1479C15.3933 28.182 15.4739 28.1997 15.5554 28.1997C15.637 28.1997 15.7176 28.182 15.7913 28.1479C18.6822 26.8103 21.0749 24.9237 22.9033 22.5429C24.3607 20.6437 25.4625 18.4287 26.1783 15.9598C27.3936 11.7686 27.0782 8.33814 27.064 8.19424L27.0633 8.19291Z" stroke="#999999" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.1015 11.3993L15.2074 18.0308L11.9447 15.3782" stroke="#999999" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="pl-4">SSL SECURE PAYMENTS</p>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </section>
      <div class="mt-12 mb-8">
        <v-container>
          <Footer class="justify-center" />
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script src="https://js.stripe.com/v3/"></script>
<script>
import NavBar from '@/views/NavBar'
import Footer from '@/views/Footer'
import { mapActions } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
import {
  SETTINGS_PAGE_SUBSCRIPTION,
  SUBSCRIPTION_PLAN_PRO_MONTH_ID,
  SUBSCRIPTION_PLAN_PRO_YEAR_ID,
  SUBSCRIPTION_PLAN_BUSINESS_MONTH_ID,
  SUBSCRIPTION_PLAN_BUSINESS_YEAR_ID,
  SUBSCRIPTION_PLAN_COMPANY_MONTH_ID,
  SUBSCRIPTION_PLAN_COMPANY_YEAR_ID,
  SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID
} from '../../constant'

export default {
  name: 'Subscription',
  components: {
    NavBar,
    Footer
  },
  metaInfo(){
    let title = 'Small Business Inventory Software';
    let description = 'Choose your plan';
    switch (this.$route.params.plan) {
      case 'corporate':
        title = "Choose Your Corporate Plan: Flexible Options";
        description = 'Select your yearly corporate plan. Optimize inventory management and scale your small business efficiently.'
        break
      case 'company':
        title = "Select Your Company Plan: Monthly or Yearly";
        description = "Pick the best plan for your business. Choose between monthly or yearly subscriptions to optimize your inventory management.";
        break
      case 'business':
        title = "Choose Your Business Plan: Monthly or Yearly";
        description = "Select a subscription that fits your needs. Choose monthly or yearly plans to streamline inventory management for your business";
        break
      case 'pro':
        title = "Select Your Pro Plan: Monthly or Yearly Options";
        description = "Choose the Pro plan that fits your business. Monthly or yearly subscriptions to enhance your inventory management today.";
        break
    }
    // let p
    return {
      title: title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        }
      ]
    }
  },
  data() {
    return {
      YEAR: 'year',
      MONTH: 'month',
      UPGRADE_SUCCESS: 'success',
      subscriptionPlanProMonthId: SUBSCRIPTION_PLAN_PRO_MONTH_ID,
      subscriptionPlanProYearId: SUBSCRIPTION_PLAN_PRO_YEAR_ID,
      subscriptionPlanBusinessMonthId: SUBSCRIPTION_PLAN_BUSINESS_MONTH_ID,
      subscriptionPlanBusinessYearId: SUBSCRIPTION_PLAN_BUSINESS_YEAR_ID,
      subscriptionPlanCompanyMonthId: SUBSCRIPTION_PLAN_COMPANY_MONTH_ID,
      subscriptionPlanCompanyYearId: SUBSCRIPTION_PLAN_COMPANY_YEAR_ID,
      subscriptionPlanCorporateYearId: SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID,
      scrolled: false,
      period: null,
      yearlyPlan: null,
      monthlyPlan: null
    }
  },
  computed: {
    yearlyPlanPrice() {
      return this.yearlyPlan ? this.yearlyPlan.price : ''
    },
    monthlyPlanPrice() {
      return this.monthlyPlan ? this.monthlyPlan.price : ''
    },
    showOffBanner() {
      return (
        this.period === this.YEAR &&
        this.yearlyPlan.id !== this.subscriptionPlanCorporateYearId
      )
    },
    planName() {
      return this.yearlyPlan
        ? this.yearlyPlan.name
        : this.monthlyPlan
        ? this.monthlyPlan
        : ''
    },
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp
    }
  },
  created: async function () {
    let plans = []
    await this.$store.dispatch('user/getAllPlans').then((res) => {
      plans = res.data.data
    })

    let monthlyPlanId, yearlyPlanId
    switch (this.$route.params.plan) {
      case 'corporate':
        yearlyPlanId = this.subscriptionPlanCorporateYearId
        break
      case 'company':
        monthlyPlanId = this.subscriptionPlanCompanyMonthId
        yearlyPlanId = this.subscriptionPlanCompanyYearId
        break
      case 'business':
        monthlyPlanId = this.subscriptionPlanBusinessMonthId
        yearlyPlanId = this.subscriptionPlanBusinessYearId
        break
      case 'pro':
        monthlyPlanId = this.subscriptionPlanProMonthId
        yearlyPlanId = this.subscriptionPlanProYearId
        break
      default:
        monthlyPlanId = this.subscriptionPlanBusinessMonthId
        yearlyPlanId = this.subscriptionPlanBusinessYearId
    }
    if (monthlyPlanId)
      this.monthlyPlan = plans.find((plan) => plan.id === monthlyPlanId)
    if (yearlyPlanId)
      this.yearlyPlan = plans.find((plan) => plan.id === yearlyPlanId)
    this.period = this.YEAR
  },
  async mounted() {
    this.includeStripe('js.stripe.com/v3/')
    window.onscroll = () => {
      this.changeColor()
    }
  },
  methods: {
    ...mapActions('user', ['getAllPlans']),
    includeStripe(URL, callback) {
      const documentTag = document
      const tag = 'script'
      const object = documentTag.createElement(tag)
      const scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = '//' + URL
      if (callback) {
        object.addEventListener(
          'load',
          function (e) {
            callback(null, e)
          },
          false
        )
      }
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    async buyNow(id) {
      const payload = {
        subscriptionId: this.period === this.YEAR ? this.yearlyPlan.id : this.monthlyPlan.id
      }
      await this.$store
        .dispatch('user/checkoutsession', payload)
        .then(async (res) => {
          if (res && res.stripeRedirect) {
            const stripePromise = loadStripe(res.stripePublicKey)
            const stripe = await stripePromise
            const result = await stripe.redirectToCheckout({
                sessionId: res.stripeSessionId
              }).then((response) => {
                this.$store.dispatch({
                  subscriptionId: id,
                  stripeSubscription: response
                })
              })
          } else {
            this.$router.push(
              {
                name: 'UserSettings'
              },
              () => {
                this.$store.dispatch(
                  'setSettingsPageSection',
                  SETTINGS_PAGE_SUBSCRIPTION
                )
                if (res && res.result === this.UPGRADE_SUCCESS) {
                  this.$store.dispatch(
                    'showUpgradeSubscriptionPlanSuccessPopup'
                  )
                  this.$store.dispatch(
                    'user/getUserByToken',
                    localStorage.getItem('querytoken')
                  )
                } else {
                  this.$store.dispatch('showUpgradeSubscriptionPlanFailedPopup')
                }
              }
            )
          }
        })
    },
    checkout() {
      this.$refs.checkoutRef.redirectToCheckout()
    },
    changeColor() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        this.scrolled = true
      } else {
        this.scrolled = false
      }
    },
    back() {
      this.$router.go(-1)
    },
    setPeriod(period) {
      this.period = period
    }
  }
}
</script>

<style lang="scss">
.information__block {
  color: #999999;
}
.sub-section {
  margin-top: 60px;
}
.v-application .information-dop .text-subtitle-1 {
  font-size: 13px !important;
  font-weight: normal;
  line-height: 1.3rem !important;
  letter-spacing: 0.03em !important;
  font-family: 'Roboto', sans-serif !important;
}
.btn-block .v-btn {
  font-size: 16px;
  min-width: 140px !important;
}
.change-font {
  font-family: 'Raleway', sans-serif;
}
.card-title {
  background-color: #5a5d5f;
  color: white !important;
  font-weight: 800;
  font-size: 1.6em;
  letter-spacing: 0.1rem;
}
.card-price {
  font-size: 2.6em;
  font-weight: 600;
  font-family: sans-serif;
  color: black !important;
}
.card-price .period {
  font-size: 0.8rem;
}
.and-price {
  font-size: 18px;
  display: block;
  color: #b5b5b5 !important;
  font-weight: 700;
  font-family: sans-serif;
}
.price-button {
  font-size: 1.25em !important;
  border-radius: 4px;
  margin-bottom: 8px;
  letter-spacing: 0.1rem;
  font-weight: bold;
  opacity: 0.7;
  height: 45px !important;
  transition: all 0.2s;
  width: 225px;
  max-width: 100%;
  border-color: #524e86 !important;
  background-color: #585382 !important;
  color: white !important;
}
.durable-transition {
  transition: all 0.5s;
}
.nav-pricing {
  margin-left: 30px;
  font-weight: 700;
  font-size: 14px;
  margin-top: 8px;
  &:hover {
    .menu-before {
      position: relative;
      top: -12px;
      left: -15px;
      content: '';
      height: 3px;
      width: 12px;
      background-color: #5f55b8;
    }
  }
}
.off-text-yearly {
  background-color: #ff551f;
  color: white;
  position: relative;
  top: 10px;
  left: -140px;
  padding: 10px 16px 16px;
  border-radius: 8px;
  font-size: 30px !important;
  font-weight: 600;
  letter-spacing: 1px;
}
.off-text-yearly span,
.off-text-monthly span {
  font-size: 15px;
  font-weight: 400;
}
.off-text-yearly:after {
  content: '';
  position: absolute;
  top: 20%;
  left: 135%;
  margin-left: -50px;
  width: 0;
  height: 0;
  border-bottom: solid 20px transparent;
  border-top: solid 20px transparent;
  border-left: solid 20px #ff551f;
}
.off-text-monthly {
  background-color: #fff;
  color: #ff551f;
  position: relative;
  top: 10px;
  left: -143px;
  padding: 10px 16px 16px;
  border-radius: 8px;
  border: solid 1px #ff551f;
  font-size: 30px !important;
  font-weight: 600;
  letter-spacing: 1px;
}
.off-text-monthly:after {
  color: #7671bd;
  position: absolute;
  top: 34%;
  left: 100%;
  width: 20px;
  height: 20px;
  border-top: 1px solid #ff551f;
  border-right: 1px solid #ff551f;
  border-bottom: 0px solid blue;
  border-left: 0px solid blue;
  content: '';
  margin-left: -9px;
  transform: rotate(45deg);
  background-color: white;
}
.footer-nav a {
  text-decoration: none;
  color: #767676;
  font-size: 16px;
}
.footer-nav a:hover {
  color: #7671bd;
}
.nav-icon {
  display: none;
}
.main-subtitle {
  padding: 0 16px;
  text-align: center;
}
.abs-disc {
  position: absolute;
  top: 0px;
  left: 0px;
}
.v-application .discount-block {
  box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 7px 25px 0 rgb(0 0 0 / 3%),
    0 4px 12px 0 rgb(0 0 0 / 3%) !important;
}
.discount-block .v-input {
  box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 7px 25px 0 rgb(0 0 0 / 3%),
    0 4px 12px 0 rgb(0 0 0 / 3%);
  border-radius: 6px;
}
.pay-block .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0;
}
@media (max-width: 1023px) {
  .information-dop .theme--light.v-divider {
    display: none;
  }
}
@media (max-width: 992px) {
  .abs-disc {
    text-align: right;
    position: absolute;
    right: 0;
    left: auto;
  }
  .off-text-yearly:after,
  .off-text-monthly:after {
    display: none;
  }
  .v-application .off-text-yearly,
  .v-application .off-text-monthly {
    font-size: 1rem !important;
  }
  .off-text-yearly,
  .off-text-monthly {
    font-size: 1rem !important;
    left: -15px;
    padding: 10px;
  }
  .main-title .change-font {
    font-size: 36px;
  }
  .main-subtitle .change-font {
    font-size: 22px !important;
  }
  .v-application--wrap > .v-main {
    padding-top: 62px !important;
  }
}
@media (max-width: 768px) {
  .main-title {
    padding: 0 16px;
  }
  .main-subtitle {
    padding: 0 16px;
  }
  .v-input--selection-controls {
    margin-top: 28px;
  }
  .main-title .change-font {
    font-size: 34px;
  }
  .discount-block .v-input {
    box-shadow: none !important;
  }
}
@media (max-width: 640px) {
  .v-sheet.discount-block:not(.v-sheet--outlined) {
    box-shadow: none !important;
    border: solid 1px #e2e4f9;
  }
  .v-application .select-plan-title p {
    font-size: 20px !important;
    line-height: 1.7rem;
  }
  .main-title {
    padding: 0;
  }
  .main-title .change-font {
    font-size: 30px;
    line-height: 2.5rem;
  }
  .information-dop .inf-block {
    justify-content: center;
    margin: 0 20px;
  }
  .inf-imgcard {
    margin: 0 auto;
  }
}
@media (max-width: 480px) {
  .pay-block .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0;
  }
  .pay-block {
    justify-content: space-between;
  }
  .v-application .discount-block .v-radio {
    margin-right: 0px !important;
  }
  .btn-block {
    flex-direction: column-reverse;
  }
  .btn-block button {
    margin-bottom: 25px;
  }
  .v-input--selection-controls {
    margin-top: 5px;
  }
  .abs-disc {
    text-align: right;
    position: inherit;
    left: auto;
  }
  .v-application .divider-main {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
  }
}
</style>
